import { em, Skeleton } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'

const CategorySkeleton = () => {
	const isMobile = useMediaQuery(`(max-width: ${em(768)})`)
	return (
		<Skeleton h={isMobile ? '65px' : '90px'} w={isMobile ? 65 : 70}  />
	)
}

export default CategorySkeleton
